
/* eslint-disable */
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { mapState, mapActions, mapMutations } from "vuex";
import AuthBottom from "../../components/AuthBottom.vue";
import { common, check } from "@/common/index";
import getMsgMx from "../mixins/getMsg.js";
import { checkOne, checkOne5 } from "@/common/utils/validate.js";
import formStyleChangeMX from "../mixins/formStyleChange.js";

import loginMx from "@/common/mixin/login/";
let ruleForm = {
username: "",
phone: "",
password: "",

timestamp: "",
};
export default {
name: "login",
components: {
XHeader,
XInput,
Group,
XButton,
AuthBottom,
},
mixins: [getMsgMx, loginMx, formStyleChangeMX(ruleForm)],
data() {
return {
telegram_credential: window.telegram_credential,
loginType: "account",

submitLoading: false, // 提交
passwordType: "password",
securityCodeSrc: "",
ruleForm,
};
},
computed: {
...mapState({
showLogin: (state) => state.showLogin,
jinGameItem: (state) => state.jinGameItem,
isLogin: (state) => state.isLogin,
UUID: (state) => state.UUID,
frontType: (state) => state.frontType,
}),
},
watch: {
showLogin(val) {
if (val) {

this._remember_get();
for (let i in this.ruleForm) this.resetError(i);
this.changeLiveChat(false);
}
},
},
created() {},
methods: {
...mapMutations([
"set_bottom",
"SET_LOGIN_SHOW",
"SET_LOGIN_HIDE",
"SET_JIN_GAMEITEM",
"SET_REGISTER",
]),
handleSubmit() {
if (this.checkSubmit()) {
this._remember_set();
this.submitLoading = true;

if (this.telegram_credential) {

this.$api.post(
this.$urls.USER.bindingAccount,
{
userAccount: this.ruleForm.username,
password: this.ruleForm.password,
hasBinding: true,
bindingCode: sessionStorage.getItem("bandingCode"),
},
(res) => {
if (res.data.code === 200) {
let { uuid, loginSuccess } = res.data.data;

if (loginSuccess && uuid) {
this.$Cookies.set("UUID", uuid);
common.logedUserInfo();
this.checkLogin(); 


this._getMsgLists({
UUID: uuid,
read: 0,
}); // 获取未读站内信条数 0未读 1 已读
this.submitLoading = false;
}
} else {
this.$vux.toast.show({
text: res.data.msg,
type: "cancel",
});
this.submitLoading = false;
}
}
);
} else {
this.$api.post(
this.$urls.USER.LOGIN,
{
username:
this.loginType === "account"
? this.ruleForm.username
: this.ruleForm.phone,
password: this.ruleForm.password,
},
(resp) => {
if (resp.data.code === undefined) {
if (resp.data.data.code === 200) {
let data = resp.data.data;
if (data["UUID"]) {
this.$Cookies.set("UUID", data["UUID"]);
common.logedUserInfo();
this.checkLogin(); 
}
this.submitLoading = false;
} else {

this.$vux.toast.show({
text: resp.data.data.msg,
type: "cancel",
});
this.submitLoading = false;
}
} else {

const msg = resp.data.msg ? resp.data.msg : resp.data.message;
this.$vux.toast.show({ text: msg, type: "cancel" });
this.submitLoading = false;
}
},
(err) => {
this.submitLoading = false;
}
);
}
}
},
_changePasswordType() {

this.passwordType =
this.passwordType === "password" ? "text" : "password";
},
handleRegister() {

this.SET_LOGIN_HIDE();
let timer = setTimeout(() => {

this.$router.push({ path: "/register" });
clearTimeout(timer);
}, 200);
},
_forgetPwd() {

this.SET_LOGIN_HIDE();
this.$router.push({ path: "/forgetPassword" });
},
connectServe() {

this.SET_LOGIN_HIDE();
this.$router.replace({ path: "/Service" });
},
getVifyCode() {

this.ruleForm.vrifyCode = "";
let randomStr = common.randomRange(16);
let timer = Math.floor(Date.now() / 1000);
this.securityCodeSrc =
this.$urls.USER.REGISTERCODE + `?timestamp=${timer}` + randomStr;
this.ruleForm.timestamp = timer + randomStr;
},
checkSubmit() {

let isOK = true;


if (isOK && !checkOne5(this.ruleForm.username)) {
this.$vux.toast.show({
text: this.$t("register").userError,
type: "cancel",
});
isOK = false;
}

if (isOK && !checkOne(this.ruleForm.password)) {
this.$vux.toast.show({
text: this.$t("register.passwordError"),
type: "cancel",
});
isOK = false;
}








return isOK;
},
_close() {

this.ruleForm = Object.assign({}, ruleForm);
this.changeLiveChat(true);
this.SET_LOGIN_HIDE();
},
...mapActions(["checkLogin"]),
},
destroyed() {

},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/login/index.vue